import { SubscriptionTypeEnum } from "./enums"

export type FeatureLimits = {
  maxInventoryItems: number | null // null = unlimited
  canCreateListings: boolean
  canPrintBarcodes: boolean
  canViewAnalytics: boolean
  canExportData: boolean
  canRecordSales: boolean
  canUseAdvancedFilters: boolean
  canAccessAPI: boolean
  hasMultiUserAccess: boolean
  hasPrioritySupport: boolean
}

export const SUBSCRIPTION_LIMITS: Record<SubscriptionTypeEnum, FeatureLimits> = {
  [SubscriptionTypeEnum.Free]: {
    maxInventoryItems: 10,
    canCreateListings: true,
    canPrintBarcodes: false,
    canViewAnalytics: false,
    canExportData: false,
    canRecordSales: false,
    canUseAdvancedFilters: false,
    canAccessAPI: false,
    hasMultiUserAccess: false,
    hasPrioritySupport: false
  },
  [SubscriptionTypeEnum.Basic]: {
    maxInventoryItems: 200,
    canCreateListings: true,
    canPrintBarcodes: false,
    canViewAnalytics: true, // Basic analytics included
    canExportData: false,
    canRecordSales: true,
    canUseAdvancedFilters: false,
    canAccessAPI: false,
    hasMultiUserAccess: false,
    hasPrioritySupport: false
  },
  [SubscriptionTypeEnum.Premium]: {
    maxInventoryItems: 1000,
    canCreateListings: true,
    canPrintBarcodes: true,
    canViewAnalytics: true,
    canExportData: true,
    canRecordSales: true,
    canUseAdvancedFilters: true,
    canAccessAPI: false,
    hasMultiUserAccess: false,
    hasPrioritySupport: true
  },
  [SubscriptionTypeEnum.Enterprise]: {
    maxInventoryItems: null, // unlimited
    canCreateListings: true,
    canPrintBarcodes: true,
    canViewAnalytics: true,
    canExportData: true,
    canRecordSales: true,
    canUseAdvancedFilters: true,
    canAccessAPI: true,
    hasMultiUserAccess: true,
    hasPrioritySupport: true
  }
}

export const getFeatureLimits = (subscription?: SubscriptionTypeEnum): FeatureLimits => {
  if (!subscription) {
    return SUBSCRIPTION_LIMITS[SubscriptionTypeEnum.Free]
  }
  return SUBSCRIPTION_LIMITS[subscription]
}

export const canAddInventoryItem = (
  currentCount: number,
  subscription: SubscriptionTypeEnum
): boolean => {
  const limits = getFeatureLimits(subscription)
  if (limits.maxInventoryItems === null) return true
  return currentCount < limits.maxInventoryItems
}

export const getRemainingInventorySlots = (
  currentCount: number,
  subscription: SubscriptionTypeEnum
): number | null => {
  const limits = getFeatureLimits(subscription)
  if (limits.maxInventoryItems === null) return null // unlimited
  return Math.max(0, limits.maxInventoryItems - currentCount)
}
